export default __webpack_public_path__ + "static/media/new-air-icon.c13e3ab1.svg";